import React, { useState } from "react";
import { X } from "lucide-react";
import { BASE_URL } from "utils/constant";

const ContractorUpdate = ({ contractor, onClose, onUpdated }) => {
  const [formData, setFormData] = useState({
    name: contractor?.name || "",
    contact: contractor?.contact || "",
    address: contractor?.address || "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    try {
      const accessToken = localStorage.getItem("access");
      const response = await fetch(
        `${BASE_URL}/org/contractors/${contractor.id}/update/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            name: formData.name,
            contact: formData.contact,
            address: formData.address,
          }),
        }
      );

      const data = await response.json();

      if (response.ok && (data.status === true || data.success === true || data.id || data.name)) {
        if (typeof onUpdated === "function") {
          onUpdated({
            name: formData.name,
            contact: formData.contact,
            address: formData.address,
          });
        }
        onClose();
      } else {
        setError(data.message || "Failed to update contractor");
      }
    } catch (err) {
      setError("An error occurred while updating contractor");
      // eslint-disable-next-line no-console
      console.error("Error updating contractor:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-[#232323]">Contractor Update</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-[#232323] mb-1">
                Contractor Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent"
                placeholder="Enter contractor name"
              />
            </div>

            <div>
              <label htmlFor="contact" className="block text-sm font-medium text-[#232323] mb-1">
                Contact Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="contact"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent"
                placeholder="Enter contact number"
              />
            </div>

            <div>
              <label htmlFor="address" className="block text-sm font-medium text-[#232323] mb-1">
                Address <span className="text-red-500">*</span>
              </label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows="3"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent resize-none"
                placeholder="Enter contractor address"
              />
            </div>
          </div>

          <div className="flex gap-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-[#3B0069] text-white rounded-lg hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Updating..." : "Update Contractor"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractorUpdate;


